var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('b-row',{staticClass:"d-flex flex-row align-items-start justify-content-center w-100 body-container",attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"d-flex flex-column align-items-center justify-content-start justify-content-lg-center px-0 py-3 inner-container",attrs:{"cols":"12","lg":"8","xl":"6"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }